import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { setNavigator } from '../utils/navigator.js'

/**
 * This component facilitates a workaround that allows us to call nagivate() outside of components. Initialize by placing this component inside a parent component to the current page (currently resides in BusinessEntity.jsx). Use by importing navigate from navigator.js
 */
const NavigatorComponent = () => {
    const navigate = useNavigate()
    useEffect(
        () => {
            setNavigator(navigate)
        },
        [navigate]
    )
    return <></>
}
export default NavigatorComponent